import { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";

type Option = { value: string; label: string; hint?: string };

export function Combobox({ value, onValueChange, options, placeholder, emptyText, disabled = false, nonMutating = false }: {
  value: string;
  onValueChange: (value: string) => void;
  options: Option[];
  placeholder: string;
  emptyText: string;
  disabled?: boolean;
  nonMutating?: boolean;
}) {
  const [open, setOpen] = useState(false);
  const selected = options.find((option) => option.value === value);
  return <Popover open={open} onOpenChange={setOpen}>
    <PopoverTrigger asChild>
      <Button type="button" data-nonmutating={nonMutating || undefined} variant="outline" role="combobox" aria-expanded={open} disabled={disabled} className="w-full justify-between font-normal">
        <span className="truncate">{selected?.label ?? placeholder}</span><ChevronsUpDown className="ml-2 size-4 shrink-0 opacity-50" />
      </Button>
    </PopoverTrigger>
    <PopoverContent className="w-(--radix-popover-trigger-width) p-0" align="start">
      <Command>
        <CommandInput data-nonmutating={nonMutating || undefined} placeholder={placeholder} />
        <CommandList><CommandEmpty>{emptyText}</CommandEmpty><CommandGroup>
          {options.map((option) => <CommandItem key={option.value} value={`${option.label} ${option.hint ?? ""}`} onSelect={() => { onValueChange(option.value); setOpen(false); }}>
            <Check className={cn("size-4", value === option.value ? "opacity-100" : "opacity-0")} />
            <span className="min-w-0"><span className="block truncate">{option.label}</span>{option.hint && <span className="block truncate text-xs text-muted-foreground">{option.hint}</span>}</span>
          </CommandItem>)}
        </CommandGroup></CommandList>
      </Command>
    </PopoverContent>
  </Popover>;
}
